import React, { Component } from 'react';
import { DatePicker, Tabs, Button, Radio, Input, message, Select, ConfigProvider } from 'antd';
import DocumentTitle from 'react-document-title';
import API from '../../../api/api';
import moment from 'moment';
import UEditor from "../ueditor/ueditor";
import './publishActivity.less';
import ColorPicker from '../../components/colorPicker/colorPicker';
import zhCN from 'antd/es/locale/zh_CN';
var uploader = require('../../../thirdTool/alioss/upload.js');
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

message.config({
    top: 200,
    duration: 2,
    maxCount: 3,
});
class PublishActivity extends Component {
    constructor(props) {
        super(props)
    }
    state = {
        hasClicked: false,
        activityId: '',//查看活动详情时的活动Id
        activityStartTime: '',//活动开始时间
        activityEndTime: '',//活动结束时间
        joinEndTime: '',//报名结束时间
        defaultMoment: [],// 查看活动详情时的初始化moment数组
        defaultJoinEndMoment: null,
        activityTitle: '',//活动标题
        qTotalnum: '',//答题类题目数量
        questionPrizeCount: '',//本期活动奖金
        activityPic: '',//主页图片
        isChooseActivityPicInitUpload: false,//主页图片上传是否初始化
        activityVideo: '',//主页视频
        isChooseActivityVideoInitUpload: false, // 主页视频上传是否初始化
        activityCard: '',//活动全色卡片
        activityCardWithBottom: '',//活动带底卡片
        activityCardFontColor: '',//卡片字体颜色
        activitySlogan: '',//活动宣传语
        desc: '',//活动详情
        readAmount: '',//阅读数
        wallHeadImage: '',//红包墙背景
        circleId: '',//公众圈Id
        objectIds: '',//社区Ids或者现场Ids
        intoLimit: '',//最低红包卡限制
        freeNum: '',//免费领取次数
        hbCardLimitNo: '',//红包卡使用次数
        relateCircleId: '',//相关公众圈Id
        circleIds: ['', '', ''],//circleIds加入公众圈
        yidunGapScore: '',//蚁盾分限制
        congratulation: '',//祝贺语
        hbBackgroundImage: '',//领取详情页背景图
        drawSlogan: '',//领取详情页文案
        honourNum: '',//红榜最大展位数
        hasOutPage: 1,//外部活动页
        outTitle: '',//外部活动验证页标题
        outHeadImage: '',//外部活动头图
        outContent: '',//外部活动详情  
        shareTitle: '',//链接卡标题
        shareGreeting: '',//链接卡祝福语
        shareStory: '',//故事
        displayColorPicker: false,
        linkDesc: '',//铛铛助手摘要  
        linkTitle: '',//铛铛助手标题
        linkImage: '',//铛铛助手头图
        joinLinkDesc: '',//铛铛助手摘要  
        joinLinkTitle: '',//铛铛助手标题
        joinLinkImage: '',//铛铛助手头图
        pre5LinkDesc: '',//铛铛助手摘要  
        pre5LinkTitle: '',//铛铛助手标题
        pre5LinkImage: '',//铛铛助手头图
        bounceImage: '',//弹起海报图片
        activityType: 0,//活动类型
        relationType: 0,//参与条件
        objectType: '',//社区类型
        objectId: '',
        sceneType: '',//现场类型
        movingScene: '',//移动现场
        addPicModalVisible: true,//添加领取详情页图片
        drawImage: [],//领取详情页图片列表
        errorArr: null,
        objectTypeList: [],//社区类型列表
        sceneTypeList: [{ objectName: '咖啡厅', objectType: 1 },
        { objectName: '电影院', objectType: 2 },
        { objectName: '酒吧KTV', objectType: 3 },
        { objectName: '机场', objectType: 4 },
        { objectName: '火车站', objectType: 5 },
        { objectName: '检测站', objectType: 6 },
        { objectName: '4S店', objectType: 7 },
        { objectName: '体育场馆', objectType: 8 },
        { objectName: '大学', objectType: 9 },
        { objectName: '餐厅', objectType: 10 },
        { objectName: '商场', objectType: 11 },
        { objectName: '酒店', objectType: 12 },
        { objectName: '超市', objectType: 13 },
        { objectName: '剧院', objectType: 14 },
        { objectName: '健身房', objectType: 15 },
        { objectName: '茶馆', objectType: 16 },
        { objectName: '图书馆', objectType: 17 },
        { objectName: '地铁站', objectType: 18 },
        { objectName: '景点', objectType: 19 },
        { objectName: '商圈', objectType: 20 }
        ],//现场类型列表
        tabsKey: '1',// 主页图片或者视频选择

        getActivity: true,
    }
    async getPictureInfo(url) { // 获取图片信息
        let result = await API.syncPic({ url: url });
        if (!result) return;
        if (result) {
            let picObj = {
                picture: url,
                width: result.ImageWidth.value,
                height: result.ImageHeight.value
            }
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };
    async getVideoInfo(url) { // 获取视频信息
        let result = await API.syncVideo({ videoUrl: url });
        if (!result) return;
        if (result.status == 1) {
            let picObj = {
                videoUrl: url,
                pictureUrl: result.data.pictureUrl,
                width: result.data.width,
                height: result.data.height,
                duration: result.data.duration
            };
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };
    searchObjectTypeList() {
        this.getObjectTypeList();
    }
    async getActivityDetail() { // 获取活动详情
        const { activityId } = this.state;
        let result = await API.getActivityDetail({ activityId: activityId });
        if (!result) return;
        if (result.status == 1) {
            let ttLeActivity = result.data.ttLeActivity;
            //时间处理
            let { defaultMoment, defaultJoinEndMoment } = this.state;
            defaultMoment.push(moment(ttLeActivity.startTime * 1000), moment(ttLeActivity.endTime * 1000));
            if (ttLeActivity.joinEndTime)
                defaultJoinEndMoment = moment(ttLeActivity.joinEndTime * 1000)


            this.setState({
                defaultMoment,
                defaultJoinEndMoment,
                activityStartTime: ttLeActivity.startTime * 1000,
                activityEndTime: ttLeActivity.endTime * 1000,
                joinEndTime: ttLeActivity.joinEndTime ? ttLeActivity.joinEndTime * 1000 : 0,
                activityType: ttLeActivity.activityType,
                relationType: ttLeActivity.relationType,
                hasOutPage: ttLeActivity.hasOutPage,
                activityTitle: ttLeActivity.title,
                activitySlogan: ttLeActivity.slogan,
                activityCardFontColor: ttLeActivity.activityCardFontColor,
                desc: ttLeActivity.desc,
                qTotalnum: ttLeActivity.qTotalnum,
                readAmount: ttLeActivity.readAmount,
                intoLimit: String(ttLeActivity.intoLimit),
                freeNum: ttLeActivity.freeNum,
                hbCardLimitNo: ttLeActivity.hbCardLimitNo,
                relateCircleId: ttLeActivity.relateCircleId,
                circleIds: JSON.parse(ttLeActivity.circleIds),
                yidunGapScore: ttLeActivity.yidunGapScore,
                congratulation: ttLeActivity.congratulation,
                drawSlogan: ttLeActivity.drawSlogan,
                honourNum: ttLeActivity.honourNum,
                outTitle: ttLeActivity.outTitle,
                outContent: ttLeActivity.outContent,
                linkTitle: ttLeActivity.linkTitle,
                linkDesc: ttLeActivity.linkDesc,
                joinLinkTitle: ttLeActivity.joinLinkTitle,
                joinLinkDesc: ttLeActivity.joinLinkDesc,
                pre5LinkTitle: ttLeActivity.pre5LinkTitle,
                pre5LinkDesc: ttLeActivity.pre5LinkDesc,
                shareTitle: ttLeActivity.shareTitle,
                shareGreeting: ttLeActivity.shareGreeting,
                shareStory: ttLeActivity.shareStory,
                circleId: ttLeActivity.circleId,
                objectId: ttLeActivity.objectId ? ttLeActivity.objectId : '',
                objectIds: ttLeActivity.objectIds,
                objectType: ttLeActivity.objectType,
                drawImage: ttLeActivity.drawImage ? JSON.parse(ttLeActivity.drawImage) : [],
                questionPrizeCount: ttLeActivity.questionPrizeCount ? ttLeActivity.questionPrizeCount / 100 : 0
            }, () => {
                // 社区类型列表
                this.searchObjectTypeList();
                //图片类型处理
                let buttonList = [
                    { buttonID: 'chooseActivityVideo', picObj: ttLeActivity.video ? JSON.parse(ttLeActivity.video) : '' },
                    { buttonID: 'chooseActivityPic', picObj: ttLeActivity.picture ? JSON.parse(ttLeActivity.picture) : '' },
                    { buttonID: 'chooseActivityCard', picObj: ttLeActivity.activityCard ? JSON.parse(ttLeActivity.activityCard).picture : '' },
                    { buttonID: 'chooseActivityCardWithBottom', picObj: ttLeActivity.activityCardWithBottom ? JSON.parse(ttLeActivity.activityCardWithBottom).picture : '' },
                    { buttonID: 'chooseWallHeadImage', picObj: ttLeActivity.wallHeadImage ? JSON.parse(ttLeActivity.wallHeadImage).picture : '' },
                    { buttonID: 'chooseDrawImage', picObj: ttLeActivity.hbBackgroundImage ? JSON.parse(ttLeActivity.hbBackgroundImage) : '' },
                    { buttonID: 'chooseOutActivityHeadImage', picObj: ttLeActivity.outHeadImage ? JSON.parse(ttLeActivity.outHeadImage) : '' },
                    { buttonID: 'chooseLinkImage', picObj: ttLeActivity.linkImage ? JSON.parse(ttLeActivity.linkImage) : '' },
                    { buttonID: 'chooseBounceImage', picObj: ttLeActivity.bounceImage ? JSON.parse(ttLeActivity.bounceImage) : '' }
                ]
                if (ttLeActivity.activityType == 2) {
                    buttonList.push(
                        { buttonID: 'chooseJoinLinkImage', picObj: ttLeActivity.joinLinkImage ? JSON.parse(ttLeActivity.joinLinkImage) : '' }
                    )
                    buttonList.push(
                        { buttonID: 'choosePre5LinkImage', picObj: ttLeActivity.pre5LinkImage ? JSON.parse(ttLeActivity.pre5LinkImage) : '' }
                    )
                    setTimeout(() => {
                        this.initUpload({
                            buttonID: 'chooseJoinLinkImage', picType: 'joinLinkImage', extensions: 'jpg,png,bmp,jpeg'
                        })
                        this.initUpload({
                            buttonID: 'choosePre5LinkImage', picType: 'pre5LinkImage', extensions: 'jpg,png,bmp,jpeg'
                        })
                    }, 100)
                }
                const state = {};
                buttonList.map((item) => {
                    if (item.picObj) {
                        let picObj = item.picObj;

                        switch (item.buttonID) {
                            case 'chooseActivityVideo':
                                Object.assign(state,{
                                    activityVideo: picObj,
                                    tabsKey: '2'
                                });
                                break;
                            case 'chooseActivityPic':
                                Object.assign(state,{
                                    activityPic: picObj
                                });
                                break;
                            case 'chooseActivityCard':
                                Object.assign(state,{
                                    activityCard: picObj
                                });
                                break;
                            case 'chooseActivityCardWithBottom':
                                Object.assign(state,{
                                    activityCardWithBottom: picObj
                                });
                                break;
                            case 'chooseWallHeadImage':
                                Object.assign(state,{
                                    wallHeadImage: picObj
                                });
                                break;
                            case 'chooseDrawImage':
                                Object.assign(state,{
                                    hbBackgroundImage: picObj
                                });
                                break;
                            case 'chooseOutActivityHeadImage':
                                Object.assign(state,{
                                    outHeadImage: picObj
                                });
                                break;
                            case 'chooseLinkImage':
                                Object.assign(state,{
                                    linkImage: picObj
                                });
                                break;
                            case 'chooseJoinLinkImage':
                                Object.assign(state,{
                                    joinLinkImage: picObj
                                });
                                break;
                            case 'choosePre5LinkImage':
                                Object.assign(state,{
                                    pre5LinkImage: picObj
                                });
                                break;
                            case 'chooseBounceImage':
                                Object.assign(state,{
                                    bounceImage: picObj
                                });
                                break;
                        }

                        if (document.getElementById(item.buttonID) && item.buttonID != 'chooseActivityVideo') {
                            if (picObj.picture)
                                document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj.picture + ')';
                            else if (picObj.pictureUrl)
                                document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj.pictureUrl + ')';
                            else {
                                document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj + ')';
                            }
                        }
                    }
                })
                this.setState({...state, getActivity: false },()=>{
                    buttonList.map((item) => {
                        if (item.picObj) {
                            let picObj = item.picObj;
                            if (document.getElementById(item.buttonID) && item.buttonID != 'chooseActivityVideo') {
                                if (picObj.picture)
                                    document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj.picture + ')';
                                else if (picObj.pictureUrl)
                                    document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj.pictureUrl + ')';
                                else {
                                    document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj + ')';
                                }
                            }
                        }
                    })
                });
            })

            // //图片处理和编辑器处理
            setTimeout(() => {

            }, 100)
        }
        else {
            message.error(result.msg);
        }
    };
    async getObjectTypeList() { // 获取社区列表
        const { circleId } = this.state;
        let result = await API.getObjectTypeList({ circleId: circleId });
        if (!result) return;
        if (result.status == 1) {
            this.setState({
                objectTypeList: result.data
            })
        }
        // else {
        //     message.error(result.msg);
        // }
    };
    async publishActivity(params) { // 发布活动
        let result = await API.publishActivity(params);
        const { activityType } = this.state;
        if (!result) return;
        if (result.status == 1) {
            message.success(result.msg);
            if (activityType == 2) {
                window.location.href = '/console/jsps/ttleActivity/newTtleActivityList.jsp?pagecurr=1'
            }
            else {
                window.location.href = '/console/jsps/ttleActivity/newTtleActivityList2.jsp?pagecurr=1'
            }
        }
        else {
            message.error(result.msg);
        }
    };
    componentDidMount() {
        if (this.getQueryString('activityId') && this.getQueryString('activityId') != 'null') {
            this.setState({
                activityId: this.getQueryString('activityId')
            }, () => {
                this.getActivityDetail();
            })
        } else {
            this.setState({ getActivity: false })
        }
        let self = this;
        let { errorArr } = this.state;
        errorArr = new Map([//初始化错误信息列表 
            ['startTime', false],//活动开始时间
            ['endTime', false],//活动结束时间
            ['joinEndTime', false],//报名结束时间
            ['title', false],//活动标题
            ['activityPic', false],//主页图片
            ['activityVideo', false],//主页视频
            ['activityCard', false],//全色卡片
            ['activityCardWithBottom', false],//带底卡片
            ['qTotalnum', false],//
            ['questionPrizeCount', false],//本期活动奖金
            ['activityCardFontColor', false],//卡片字体颜色
            ['slogan', false],//活动宣传语
            ['readAmount', false],//阅读数
            ['desc', false],//活动详情
            ['wallHeadImage', false],//红包墙背景
            ['circleId', false],//公众圈Id
            ['objectIds', false],//社区ids或现场ids
            ['objectId', false],//社区id或现场id
            ['objectType', false],//社区类型或现场类型
            ['intoLimit', false],//最低红包卡限制
            ['freeNum', false],//免费领取次数
            ['hbCardLimitNo', false],//红包卡使用次数
            ['relateCircleId', false],//相关公众圈id
            ['circleIds', false],//加入公众圈id
            ['yidunGapScore', false],//蚁盾分
            ['congratulation', false],//祝贺语
            ['drawImage', false],//领取详情页图片
            ['hbBackgroundImage', false],//领取详情页背景图
            ['drawSlogan', false],//领取详情页文案
            ['honourNum', false],//红榜最大展位数
            ['outTitle', false],//外部活动标题
            ['outHeadImage', false],//外部活动头图
            ['outContent', false],//外部活动详情
            ['shareTitle', false],//链接卡标题
            ['shareGreeting', false],//链接卡祝福语
            ['shareStory', false],//故事
            ['linkDesc', false],//铛铛助手链接
            ['linkTitle', false],//
            ['linkImage', false],//头图
            ['bounceImage', false],//海报图
        ])
        this.setState({ errorArr, hasClicked: true })
        let buttonList = [
            {
                buttonID: 'chooseActivityPic',
                picType: 'activityPic',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseActivityVideo',
                picType: 'activityVideo',
                extensions: 'mp4',
            },
            {
                buttonID: 'chooseActivityCard',
                picType: 'activityCard',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseActivityCardWithBottom',
                picType: 'activityCardWithBottom',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseWallHeadImage',
                picType: 'wallHeadImage',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseDrawImage',
                picType: 'hbBackgroundImage',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseOutActivityHeadImage',
                picType: 'outHeadImage',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseLinkImage',
                picType: 'linkImage',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseBounceImage',
                picType: 'bounceImage',
                extensions: 'jpg,png,bmp,jpeg',
            },
        ]
        buttonList.map((item, index) => {
            self.initUpload(item)
        })
        setTimeout(() => {
            const { drawImage } = self.state;
            uploader({
                serverUrl: '/promotion/oss/policy',
                upload_button: 'chooseDetailPic',
                multi: true,
                max: '2MB',
                extensions: 'jpg,gif,png,jpeg',
                beforeUpload: function (file, up) {

                },
                added: function (up, files) {
                    if (drawImage.length + files.length > 9) {
                        alert('您只能再上传' + (9 - drawImage.length) + '张图片');
                        up.splice(0, files.length);
                    } // 首先判断是不是传的张数超出了上限
                },
                success: function (file_url, file) {
                    self.getPictureInfo(file_url).then(
                        obj => {
                            drawImage.push(obj);
                            self.setState({
                                drawImage: drawImage
                            }, () => {

                            })
                        }
                    );
                },
                error: function (res) {

                }
            })
        }, 102)
    }

    UEditorReadyDesc(ueditor) {
        if (this.getQueryString('activityId') && this.getQueryString('activityId') != 'null') {
            const { desc } = this.state;
            if (desc) {
                ueditor.setContent(desc);
            }
        }
    }

    UEditorReadyOutContent(ueditor) {
        if (this.getQueryString('activityId') && this.getQueryString('activityId') != 'null') {
            const { outContent } = this.state;
            if (outContent) {
                ueditor.setContent(outContent);
            }
        }
    }

    initUpload(item) { //初始化视频上传
        let self = this;
        setTimeout(() => {
            if (document.getElementById(item.buttonID)) {
                let { errorArr } = self.state;
                if (item.buttonID == 'chooseActivityPic') {
                    this.setState({ isChooseActivityPicInitUpload: true })
                }
                if (item.buttonID == 'chooseActivityVideo') {
                    this.setState({ isChooseActivityVideoInitUpload: true })
                }
                uploader({
                    serverUrl: window.location.origin + '/promotion/oss/policy',
                    upload_button: item.buttonID,
                    multi: false,
                    extensions: item.extensions,
                    added: function () {
                    },
                    success: function (file_url, file) {
                        let picObj;
                        if (file.type == 'video/mp4') {
                            self.getVideoInfo(file_url).then(obj => {
                                console.log('obj', obj)
                                if (item.picType == 'activityVideo') {
                                    self.setState({
                                        activityVideo: obj
                                    })
                                }
                                errorArr.set(item.picType, false);
                                self.setState({ errorArr })
                                console.log(item.picType, errorArr.get(item.picType))
                                // document.getElementById(item.buttonID).style.backgroundImage = 'url(' + obj.pictureUrl + ')';
                            })
                        } else {
                            self.getPictureInfo(file_url).then(obj => {
                                if (item.picType == 'activityPic') {
                                    self.setState({
                                        activityPic: obj
                                    })
                                } else if (item.picType == 'activityCard') {
                                    self.setState({
                                        activityCard: obj.picture
                                    })
                                } else if (item.picType == 'activityCardWithBottom') {
                                    self.setState({
                                        activityCardWithBottom: obj.picture
                                    })
                                } else if (item.picType == 'wallHeadImage') {
                                    self.setState({
                                        wallHeadImage: obj.picture
                                    })
                                } else if (item.picType == 'hbBackgroundImage') {
                                    self.setState({
                                        hbBackgroundImage: obj
                                    })
                                }
                                else if (item.picType == 'outHeadImage') {
                                    self.setState({
                                        outHeadImage: obj
                                    })
                                }
                                else if (item.picType == 'linkImage') {
                                    self.setState({
                                        linkImage: obj
                                    })
                                }
                                else if (item.picType == 'pre5LinkImage') {
                                    self.setState({
                                        pre5LinkImage: obj
                                    })
                                }
                                else if (item.picType == 'joinLinkImage') {
                                    self.setState({
                                        joinLinkImage: obj
                                    })
                                }
                                else if (item.picType == 'bounceImage') {
                                    self.setState({
                                        bounceImage: obj
                                    })
                                }
                                errorArr.set(item.picType, false);
                                self.setState({ errorArr })
                                document.getElementById(item.buttonID).style.backgroundImage = 'url(' + obj.picture + ')';
                            });
                        }
                    },
                    error: function (msg) {
                        message.error(msg)
                    }
                })
            }
        }, 100)
    }
    handleUEditorChange = (type, content) => { //编辑器
        let { errorArr, desc } = this.state;
        console.log(content, type);
        switch (type) {
            case 'desc':
                console.log('handleUEditorChange', desc == content, desc, content)
                if (desc == content) return;
                console.log('handleUEditorChange1')
                this.setState({ desc: content.trim() });
                errorArr.set('desc', content.trim() == '' ? true : false);
                break;
            case 'outContent':
                this.setState({
                    outContent: content.trim()
                });
                errorArr.set('outContent', content.trim() == '' ? true : false);
                break;
        }
        this.setState({ errorArr });
    }



    CardFontColorClick() {//拾色器点击函数
        this.setState({
            displayColorPicker: !this.state.displayColorPicker
        })
    }
    CardFontColorClose() {//拾色器关闭函数
        this.setState({
            displayColorPicker: false
        })
    }
    activityCardFontColorChange(color) {//拾色器颜色改变函数
        this.setState({
            activityCardFontColor: color.hex
        })
    }
    activityTypeChange(e) {//活动类型
        let { activityType } = this.state;
        if (activityType != 2 && e.target.value == 2) {
            this.initUpload({
                buttonID: 'chooseJoinLinkImage', picType: 'joinLinkImage', extensions: 'jpg,png,bmp,jpeg'
            })
            this.initUpload({
                buttonID: 'choosePre5LinkImage', picType: 'pre5LinkImage', extensions: 'jpg,png,bmp,jpeg'
            })
        }
        this.setState({
            activityType: e.target.value,
        });

    }
    relationTypeChange(e) {//社区类型
        this.setState({
            objectId: '',
            objectType: '',
            relationType: e.target.value,
        });
    }
    hasOutPageChange(e) {//外部活动
        let { hasOutPage } = this.state;
        if (hasOutPage == 0 && e.target.value != 0) {
            this.initUpload({
                buttonID: 'chooseOutActivityHeadImage', picType: 'outHeadImage', extensions: 'jpg,png,bmp,jpeg'
            })
            console.log(222)
        }
        this.setState({
            hasOutPage: e.target.value,
        });
    }
    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }
    dateChange(dates, dateStrings) { //时间范围变化函数
        let { errorArr } = this.state;
        if (dates.length == 0) {
            errorArr.set('startTime', true)
            errorArr.set('endTime', true)
            this.setState({ activityStartTime: 0, activityEndTime: 0, errorArr })
            return;
        }
        if (dates[0].valueOf()) {
            errorArr.set('startTime', false)
            this.setState({ activityStartTime: dates[0].valueOf(), errorArr })
        }
        if (dates[1].valueOf()) {
            errorArr.set('endTime', false)
            this.setState({ activityEndTime: dates[1].valueOf(), errorArr })
        }

    }
    dateNoRangeChange(date, dateStrings) {//时间变化函数
        let { errorArr } = this.state;
        if (date && date.valueOf()) {
            this.setState({ joinEndTime: date.valueOf() })
            errorArr.set('joinEndTime', false)
        }
        this.setState({ errorArr })
    }
    objectTypeChange(value) {//社区类型变化
        let objectType = value.split('_')[0]
        let objectId = value.split('_')[1]
        let { errorArr } = this.state;
        errorArr.set('objectType', false)
        this.setState({
            objectType: objectType,
            errorArr,
            objectId: objectId == 'null' ? null : objectId
        })
    }
    sceneTypeChange(value) {//现场类型变化
        this.setState({
            objectType: value
        })
    }
    picDel(type) {
        console.log(type)
    }
    movingSceneChange(value) {//移动现场
        this.setState({
            objectType: value
        })
    }
    handleAddModalOk = e => {//添加或编辑对话框点击确定后
    }
    handleAddModalCancel = e => {//添加或编辑对话框点击取消后
    }
    albumDel(index) {
        const { drawImage } = this.state;
        drawImage.splice(index, 1)
        this.setState({ drawImage })
    }
    saveActivity() {
        this.setState({ hasClicked: true })
        const {
            activityType,
            activityStartTime,
            activityEndTime,
            joinEndTime,
            activityTitle,
            activityPic,
            activityVideo,
            activityCard,
            activityCardWithBottom,
            qTotalnum,
            questionPrizeCount,
            activityCardFontColor,
            activitySlogan,
            readAmount,
            desc,
            wallHeadImage,
            relationType,
            circleId,
            objectIds,
            objectId,
            objectType,
            intoLimit,
            freeNum,
            hbCardLimitNo,
            relateCircleId,
            circleIds,
            yidunGapScore,
            congratulation,
            drawImage,
            hbBackgroundImage,
            drawSlogan,
            honourNum,
            hasOutPage,
            outTitle,
            outHeadImage,
            outContent,
            shareTitle,
            shareGreeting,
            shareStory,
            linkDesc,
            linkTitle,
            joinLinkDesc,//铛铛助手摘要  
            joinLinkTitle,//铛铛助手标题
            joinLinkImage,//铛铛助手头图
            pre5LinkDesc,//铛铛助手摘要  
            pre5LinkTitle,//铛铛助手标题
            pre5LinkImage,//铛铛助手头图
            linkImage,
            bounceImage,
            activityId,
            tabsKey
        } = this.state;
        let { errorArr } = this.state;
        let data = {
            startTime: activityStartTime / 1000,
            endTime: activityEndTime / 1000,
            title: activityTitle,
            activityCard,
            activityCardWithBottom,
            activityCardFontColor,
            slogan: activitySlogan,
            readAmount,
            desc: desc,
            wallHeadImage,
            congratulation,
            honourNum,
        }
        if (hasOutPage == 1) { //外部活动页
            data.outTitle = outTitle; //标题
            data.outHeadImage = outHeadImage; //头图
            data.outContent = outContent; //内容
        }
        if (relationType != 0) { //公众圈Id的必填条件
            data.circleId = circleId;
        }
        if (activityType == 3 || activityType == 4) {
            data.shareTitle = shareTitle;
            data.shareGreeting = shareGreeting;
            data.shareStory = shareStory;
        }
        if (activityType != 2) {
            data.intoLimit = intoLimit;
            data.freeNum = freeNum;
            data.hbCardLimitNo = hbCardLimitNo;
        }
        if (activityType == 2) {
            data.qTotalnum = qTotalnum;
            data.joinEndTime = joinEndTime / 1000;
            data.questionPrizeCount = questionPrizeCount * 100;
        }
        if (relationType == 2 || relationType == 8 || relationType == 6) { // 单类社区 指定社区
            if (objectId)
                data.objectId = objectId;
            data.objectType = objectType
        }
        if (relationType == 8 || relationType == 7) { //指定社区下的社区Ids
            data.objectIds = objectIds
        }
        let flag = false;
        for (let key in data) { //通用字段 上述字段处理 
            if (!data[key]) {
                errorArr.set(key, true);
                flag = true;
            }
        }
        //类型判断
        data.activityType = activityType;//活动类型
        data.relationType = relationType;//参与条件
        data.hasOutPage = hasOutPage;//外部活动页
        //主页图片或视频判断

        if (tabsKey == '1') {
            if (!activityPic) {
                errorArr.set('activityPic', true);
                flag = true;
            } else {
                data.picture = JSON.stringify(activityPic);
                delete (data.video)
            }
        }

        if (tabsKey == '2') {
            if (!activityVideo) {
                errorArr.set('activityPic', true);
                flag = true;
            } else {
                data.video = JSON.stringify(activityVideo);
                delete (data.picture)
            }
        }

        // if (activityVideo.videoUrl) { // 主页图片或视频字段传递
        //     data.video = JSON.stringify(activityVideo);
        //     delete (data.picture)
        // } else {
        //     data.picture = JSON.stringify(activityPic);
        //     delete (data.video)
        // }

        //加入公众圈Ids
        data.circleIds = JSON.stringify(circleIds)
        //铛铛助手相关
        let obj = {
            linkDesc: linkDesc,
            linkTitle: linkTitle,
            linkImage: linkImage,
            joinLinkDesc: joinLinkDesc,//铛铛助手摘要  
            joinLinkTitle: joinLinkTitle,//铛铛助手标题
            joinLinkImage: joinLinkImage,//铛铛助手头图
            pre5LinkDesc: pre5LinkDesc,//铛铛助手摘要  
            pre5LinkTitle: pre5LinkTitle,//铛铛助手标题
            pre5LinkImage: pre5LinkImage,//铛铛助手头图
        }
        for (let key in obj) {
            if (obj[key]) {
                data[key] = obj[key]
            }
        }
        if (bounceImage) {
            data.bounceImage = bounceImage;
        }
        //相关公众圈Id
        if (relateCircleId) {
            data.relateCircleId = relateCircleId;
        }
        //蚁盾高分用户限制
        if (yidunGapScore) {
            data.yidunGapScore = yidunGapScore;
        }
        //领取详情页
        if (drawImage.length > 0) {
            data.drawImage = JSON.stringify(drawImage);
        }
        if (hbBackgroundImage) {
            data.hbBackgroundImage = hbBackgroundImage;
        }
        if (drawSlogan) {
            data.drawSlogan = drawSlogan;
        }
        if (activityId) {
            data.activityId = activityId;
        }
        if (flag && document.querySelectorAll('.formItemError')[0]) {
            let firstError = document.querySelectorAll('.formItemError')[0];
            window.scrollTo(0, firstError.offsetTop - 100);
            return;
        }
        if (flag) {
            return;
        }
        this.setState({ errorArr })
        this.publishActivity(data)
    }
    inputItemChange(type, e) {
        let value = e.target.value;
        let { errorArr } = this.state;
        let newValStr = value + '';
        let reg = /^\d{1,10}(\.){0,1}(\d{1,2})?$/;
        switch (type) {
            case 'activityTitle':
                errorArr.set('title', value.trim() == '' ? true : false);
                this.setState({ activityTitle: value })
                break;
            case 'qTotalnum':
                const { qTotalnum } = this.state;
                if (value.trim() != '' && (!/^[0-9]+$/.test(value) || value == 0))
                    value = qTotalnum;
                e.target.value = value;
                errorArr.set('qTotalnum', value == '' ? true : false);
                this.setState({ qTotalnum: value })
                break;
            case 'questionPrizeCount':
                const { questionPrizeCount } = this.state;
                if ((newValStr && !reg.test(newValStr)) || (newValStr.split('.').length > 2) || (newValStr.split('.')[1] && newValStr.split('.')[1].length > 2))
                    value = questionPrizeCount;
                errorArr.set('questionPrizeCount', value == '' ? true : false);
                this.setState({ questionPrizeCount: value })
                break;
            case 'activitySlogan':
                errorArr.set('slogan', value.trim() == '' ? true : false);
                this.setState({ activitySlogan: value })
                break;
            case 'readAmount':
                const { readAmount } = this.state;
                if (value.trim() != '' && (!/^[0-9]+$/.test(value) || value == 0))
                    value = readAmount;
                e.target.value = value;
                errorArr.set('readAmount', (value == '') ? true : false);
                this.setState({ readAmount: value })
                break;
            case 'circleId':
                errorArr.set('circleId', value.trim() == '' ? true : false);
                this.setState({ circleId: value })
                break;
            case 'objectIds':
                errorArr.set('objectIds', value.trim() == '' ? true : false);
                this.setState({ objectIds: value })
                break;
            case 'intoLimit':
                const { intoLimit } = this.state;
                console.log('intoLimit=', intoLimit)
                console.log(value, value.trim() != '', /^[0-9]+$/.test(value), value == 0)
                if (value.trim() != '' && (!/^[0-9]+$/.test(value)))
                    value = intoLimit;
                e.target.value = value;
                errorArr.set('intoLimit', value == '' ? true : false);
                this.setState({ intoLimit: value })
                break;
            case 'freeNum':
                const { freeNum } = this.state;
                if (value.trim() != '' && (!/^[0-9]+$/.test(value)))
                    value = freeNum;
                e.target.value = value;
                errorArr.set('freeNum', value == '' ? true : false);
                this.setState({ freeNum: value })
                break;
            case 'hbCardLimitNo':
                const { hbCardLimitNo } = this.state;
                if (value.trim() != '' && (!/^[0-9]+$/.test(value)))
                    value = hbCardLimitNo;
                e.target.value = value;
                errorArr.set('hbCardLimitNo', value == '' ? true : false);
                this.setState({ hbCardLimitNo: value })
                break;
            case 'yidunGapScore':
                this.setState({ yidunGapScore: value })
                break;
            case 'congratulation':
                errorArr.set('congratulation', value.trim() == '' ? true : false);
                this.setState({ congratulation: value })
                break;
            case 'drawSlogan':
                this.setState({ drawSlogan: value })
                break;
            case 'honourNum':
                const { honourNum } = this.state;
                if (value.trim() != '' && (!/^[0-9]+$/.test(value)))
                    value = honourNum;
                errorArr.set('honourNum', value == '' ? true : false);
                this.setState({ honourNum: value })
                break;
            case 'shareTitle':
                errorArr.set('shareTitle', value.trim() == '' ? true : false);
                this.setState({ shareTitle: value })
                break;
            case 'shareGreeting':
                errorArr.set('shareGreeting', value.trim() == '' ? true : false);
                this.setState({ shareGreeting: value })
                break;
            case 'shareStory':
                errorArr.set('shareStory', value.trim() == '' ? true : false);
                this.setState({ shareStory: value })
                break;
            case 'outTitle':
                errorArr.set('outTitle', value.trim() == '' ? true : false);
                this.setState({ outTitle: value })
                break;
            case 'linkTitle':
                this.setState({ linkTitle: value })
                break;
            case 'joinLinkTitle':
                this.setState({ joinLinkTitle: value })
                break;
            case 'pre5LinkTitle':
                this.setState({ pre5LinkTitle: value })
                break;
            case 'relateCircleId':
                this.setState({ relateCircleId: value })
                break;
            case 'linkDesc':
                this.setState({ linkDesc: value })
                break;
            case 'joinLinkDesc':
                this.setState({ joinLinkDesc: value })
                break;
            case 'pre5LinkDesc':
                this.setState({ pre5LinkDesc: value })
                break;
        }
        this.setState({ errorArr })
    }
    inputCircleIdsChange(index, e) {
        const { circleIds } = this.state;
        circleIds[index] = e.target.value;
        this.setState({ circleIds })
    }
    numberOnKeyPress(event) {
        console.log(event.target.value)
        event.target.value = event.target.value.replace(/^[1-9]\d*$/, '');
    }
    goBack() {
        this.props.history.go(-2)
    }

    tabsCallback(key) {
        console.log(key)
        this.setState({ tabsKey: key })
        if (key == 2 && !this.state.isChooseActivityVideoInitUpload) {
            this.setState({ isChooseActivityVideoInitUpload: true })
            this.initUpload({
                buttonID: 'chooseActivityVideo',
                picType: 'activityVideo',
                extensions: 'mp4',
            })
        }
        if (key == 1 && !this.state.isChooseActivityPicInitUpload) {
            this.setState({ isChooseActivityPicInitUpload: true })
            this.initUpload({
                buttonID: 'chooseActivityPic',
                picType: 'activityPic',
                extensions: 'jpg,png,bmp,jpeg',
            })
        }
        if (key == 1 && this.state.activityVideo) {
            document.getElementById("video").pause()
        }
    }
    render() {
        const {
            hasClicked,
            displayColorPicker,
            activityType,
            activityId,
            relationType,
            objectType,
            sceneType,
            drawImage,
            hasOutPage,
            objectTypeList,
            sceneTypeList,
            activityTitle,
            activitySlogan,
            qTotalnum,
            questionPrizeCount,
            activityCardFontColor,
            desc,
            readAmount,
            errorArr,
            intoLimit,
            freeNum,
            hbCardLimitNo,
            relateCircleId,
            circleIds,
            defaultMoment,
            defaultJoinEndMoment,
            yidunGapScore,
            congratulation,
            drawSlogan,
            honourNum,
            outTitle,
            linkTitle,
            linkDesc,
            linkImage,
            joinLinkTitle,
            joinLinkDesc,
            joinLinkImage,
            pre5LinkTitle,
            pre5LinkDesc,
            pre5LinkImage,
            bounceImage,
            shareTitle,
            shareGreeting,
            shareStory,
            circleId,
            objectId,
            objectIds,
            activityVideo,
            activityPic,
            getActivity,
        } = this.state;
        return (
            <DocumentTitle title="发布天天乐活动">
                <ConfigProvider locale={zhCN}>
                    <div className="PublishActivityPane">
                        <Button onClick={this.goBack.bind(this)}>返回上一页</Button>
                        <div className="inputItem">
                            <span className="inputTitle">活动类型</span>
                            <Radio.Group onChange={this.activityTypeChange.bind(this)} value={activityType} disabled={activityId && activityId != 'null' ? true : false}>
                                <Radio value={0}>普通天天乐红包</Radio>
                                <Radio value={1}>普通答题</Radio>
                                <Radio value={2}>直播答题</Radio>
                                <Radio value={3}>普通天天乐红包(分享)</Radio>
                                <Radio value={4}>普通答题(分享)</Radio>
                            </Radio.Group>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">活动开始-结束时间</span>
                            <RangePicker className="datePicker" defaultValue={defaultMoment} width={400} format="YYYY-MM-DD HH:mm:ss" showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')] }} onChange={this.dateChange.bind(this)} />
                            {hasClicked && (errorArr.get('startTime') || errorArr.get('endTime')) && <span className="formItemError">请填写活动开始-结束时间</span>}
                        </div>
                        {
                            activityType == 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">报名结束时间</span>
                                <DatePicker className="datePicker" defaultValue={defaultJoinEndMoment} width={400} format="YYYY-MM-DD HH:mm:ss" showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }} onChange={this.dateNoRangeChange.bind(this)} />
                                {hasClicked && errorArr.get('joinEndTime') && <span className="formItemError">请填写报名结束时间</span>}
                            </div>
                        }
                        <div className="inputItem">
                            <span className="inputTitle">活动标题</span>
                            <Input className="inputBlock" value={activityTitle} placeholder="请填写活动标题" onChange={this.inputItemChange.bind(this, 'activityTitle')}></Input>
                            {hasClicked && errorArr.get('title') && <span className="formItemError">请填写活动标题</span>}
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">主页图片或视频</span>
                            {
                                (!activityId ||
                                    (activityId && (activityVideo || activityPic))) &&
                                <div className='homePage'>
                                    <Tabs defaultActiveKey={activityVideo.videoUrl ? '2' : '1'} forceRender={true} onChange={this.tabsCallback.bind(this)}>
                                        <TabPane tab="图片" key="1">
                                            <div id="chooseActivityPic" className="chooseActivityPic"></div>
                                        </TabPane>
                                        <TabPane tab="视频" key="2">
                                            {
                                                activityVideo ?
                                                    <video
                                                        style={{maxHeight:'300px'}}
                                                        id="video"
                                                        controls
                                                        // width={activityVideo.width}
                                                        // height={activityVideo.height}
                                                        poster={activityVideo.pictureUrl}
                                                        preload='auto'
                                                        src={activityVideo.videoUrl}>
                                                    </video> :
                                                    <div id="chooseActivityVideo" className="chooseActivityPic"></div>
                                            }
                                        </TabPane>
                                    </Tabs>
                                </div>
                            }

                            {hasClicked && errorArr.get('activityPic') && <span className="formItemError" style={{ marginTop: '15px' }}>请选择主页图片或视频</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">活动全色卡片(展示抢红包按钮时)</span>
                            <div id="chooseActivityCard" className="chooseActivityPic"></div>
                            {hasClicked && errorArr.get('activityCard') && <span className="formItemError">请选择活动全色卡片</span>}
                        </div>
                        {
                            activityType == 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">题目数量</span>
                                <Input className="inputBlock" onPaste={(e) => e.preventDefault()} value={qTotalnum} onChange={this.inputItemChange.bind(this, 'qTotalnum')}></Input>
                                {
                                    hasClicked && errorArr.get('qTotalnum') &&
                                    <span className="formItemError">
                                        请填写题目数量
                                    </span>
                                }
                            </div>
                        }
                        {
                            activityType == 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">本期活动总奖金</span>
                                <Input className="inputBlock" onPaste={(e) => e.preventDefault()} value={questionPrizeCount} onChange={this.inputItemChange.bind(this, 'questionPrizeCount')}></Input>
                                {
                                    hasClicked && errorArr.get('questionPrizeCount') &&
                                    <span className="formItemError">
                                        本期活动总奖金
                                    </span>
                                }
                            </div>
                        }
                        <div className="inputItem">
                            <span className="inputTitle">活动带底卡片</span>
                            <div id="chooseActivityCardWithBottom" className="chooseActivityPic"></div>
                            {hasClicked && errorArr.get('activityCardWithBottom') && <span className="formItemError">请选择活动带底卡片</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">卡片字体颜色</span>
                            <ColorPicker
                                CardFontColorClick={this.CardFontColorClick.bind(this)}
                                CardFontColorClose={this.CardFontColorClose.bind(this)}
                                activityCardFontColorChange={this.activityCardFontColorChange.bind(this)}
                                displayColorPicker={displayColorPicker}
                                defaultColor={activityCardFontColor}
                            ></ColorPicker>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">活动宣传语</span>
                            <Input className="inputBlock" value={activitySlogan} onChange={this.inputItemChange.bind(this, 'activitySlogan')}></Input>
                            {hasClicked && errorArr.get('slogan') && <span className="formItemError">请填写活动宣传语</span>}
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">活动详情</span>
                            <div className="editorPane">
                                {
                                    !getActivity && <UEditor id='myeditor' content={desc} ready={this.UEditorReadyDesc.bind(this)} onChange={this.handleUEditorChange.bind(this, 'desc')} />
                                }
                                {hasClicked && errorArr.get('desc') && <span className="editorItemError">请填写活动详情</span>}
                            </div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">阅读数</span>
                            <Input className="inputBlock" onPaste={(e) => e.preventDefault()} value={readAmount} onChange={this.inputItemChange.bind(this, 'readAmount')}></Input>
                            {
                                hasClicked && errorArr.get('readAmount') &&
                                <span className="formItemError">
                                    请填写<span>正确的</span>阅读数
                                </span>
                            }
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">红包墙背景</span>
                            <div id="chooseWallHeadImage" className="chooseActivityPic"></div>
                            {hasClicked && errorArr.get('wallHeadImage') && <span className="formItemError">请选择红包墙背景</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">参与条件</span>
                            <Radio.Group onChange={this.relationTypeChange.bind(this)} value={relationType}>
                                <Radio value={0}>无</Radio>
                                <Radio value={3}>所有社区</Radio>
                                <Radio value={2}>单类社区</Radio>
                                <Radio value={8}>指定社区</Radio>
                                <Radio value={5}>所有现场</Radio>
                                <Radio value={9}>单类现场</Radio>
                                <Radio value={7}>指定现场</Radio>
                                <Radio value={6}>移动现场</Radio>
                            </Radio.Group>
                        </div>
                        {
                            relationType != 0 &&
                            <div className="inputItem">
                                <span className="inputTitle">公众圈Id</span>
                                <Input className="inputBlock" value={circleId} onBlur={this.searchObjectTypeList.bind(this)} onChange={this.inputItemChange.bind(this, 'circleId')}></Input>
                                {hasClicked && errorArr.get('circleId') && <span className="formItemError">请填写公众圈Id</span>}
                            </div>
                        }
                        {
                            (relationType == 2 || relationType == 8) &&
                            <div className="inputItem">
                                <span className="inputTitle">社区类型</span>
                                <Select className="selectBlock" value={circleId && objectType && objectId ? objectType + '_' + objectId : objectType} style={{ width: 200 }} onChange={this.objectTypeChange.bind(this)}>
                                    {
                                        objectTypeList.map((item, index) => {
                                            return <Option key={'objectTypeListItem' + index + item.objectType} value={item.objectId ? item.objectType + '_' + item.objectId : item.objectType}>{item.objectName}</Option>
                                        })
                                    }
                                </Select>
                                {hasClicked && errorArr.get('objectType') && <span className="formItemError">请选择社区类型</span>}
                            </div>
                        }
                        {
                            relationType == 9 &&
                            <div className="inputItem">
                                <span className="inputTitle">现场类型</span>
                                <Select className="selectBlock" value={objectType} style={{ width: 200 }} onChange={this.sceneTypeChange.bind(this)}>
                                    {
                                        sceneTypeList.map((item, index) => {
                                            return <Option key={'sceneTypeListItem' + index} value={item.objectType}>{item.objectName}</Option>
                                        })
                                    }
                                </Select>
                                {hasClicked && errorArr.get('objectType') && <span className="formItemError">请选择现场类型</span>}
                            </div>
                        }
                        {
                            relationType == 7 &&
                            <div className="inputItem">
                                <span className="inputTitle">现场Ids</span>
                                <Input className="inputBlock" value={objectIds} placeholder="现场Id间用英文逗号隔开" onChange={this.inputItemChange.bind(this, 'objectIds')}></Input>
                                {hasClicked && errorArr.get('objectIds') && <span className="formItemError">请填写至少一个现场Id</span>}
                            </div>
                        }
                        {
                            relationType == 8 &&
                            <div className="inputItem">
                                <span className="inputTitle">社区Ids</span>
                                <Input className="inputBlock" value={objectIds} placeholder="社区Id间用英文逗号隔开" onChange={this.inputItemChange.bind(this, 'objectIds')}></Input>
                                {hasClicked && errorArr.get('objectIds') && <span className="formItemError">请填写至少一个社区Id</span>}
                            </div>
                        }
                        {
                            relationType == 6 &&
                            <div className="inputItem">
                                <span className="inputTitle">选择现场</span>
                                <Select className="selectBlock" value={'' + objectType} style={{ width: 200 }} onChange={this.movingSceneChange.bind(this)}>
                                    <Option value="20">航班</Option>
                                    <Option value="10">火车</Option>
                                </Select>
                                {hasClicked && errorArr.get('objectType') && <span className="formItemError">请选择现场</span>}
                            </div>
                        }
                        {
                            activityType != 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">最低红包卡限制</span>
                                <Input className="inputBlock" onPaste={(e) => e.preventDefault()} value={intoLimit} onChange={this.inputItemChange.bind(this, 'intoLimit')}></Input>
                                {hasClicked && errorArr.get('intoLimit') && <span className="formItemError">请填写最低红包卡限制(限非负整数)</span>}
                            </div>

                        }
                        {
                            activityType != 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">免费领取次数</span>
                                <Input className="inputBlock" onPaste={(e) => e.preventDefault()} value={freeNum} onChange={this.inputItemChange.bind(this, 'freeNum')}></Input>
                                {hasClicked && errorArr.get('freeNum') && <span className="formItemError">请填写免费领取次数(限非负整数)</span>}
                            </div>
                        }
                        {
                            activityType != 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">红包卡使用次数</span>
                                <Input className="inputBlock" onPaste={(e) => e.preventDefault()} value={hbCardLimitNo} onChange={this.inputItemChange.bind(this, 'hbCardLimitNo')}></Input>
                                {hasClicked && errorArr.get('hbCardLimitNo') && <span className="formItemError">请填写红包卡使用次数(限非负整数)</span>}
                            </div>
                        }

                        <div className="inputItem">
                            <span className="inputTitle">相关公众圈Id</span>
                            <Input className="inputBlock" value={relateCircleId} onChange={this.inputItemChange.bind(this, 'relateCircleId')}></Input>
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">加入公众圈Id</span>
                            <div className="joinCircleBlock">
                                <Input className="inputBlock" value={circleIds[0]} onChange={this.inputCircleIdsChange.bind(this, 0)}></Input>
                                <Input className="inputBlock" value={circleIds[1]} onChange={this.inputCircleIdsChange.bind(this, 1)}></Input>
                                <Input className="inputBlock" value={circleIds[2]} onChange={this.inputCircleIdsChange.bind(this, 2)}></Input>
                            </div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">蚁盾分限制<br></br>（选填）</span>
                            <Input className="inputBlock" value={yidunGapScore} onChange={this.inputItemChange.bind(this, 'yidunGapScore')}></Input>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">祝贺语</span>
                            <Input className="inputBlock" value={congratulation} onChange={this.inputItemChange.bind(this, 'congratulation')}></Input>
                            {hasClicked && errorArr.get('congratulation') && <span className="formItemError">请填写祝贺语</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">领取详情页图片</span>
                            <div className="detailPicPane">
                                {
                                    drawImage.map((item, index) => {
                                        return <div className="drawBlock" key={'drawImageItem' + index} style={{ 'backgroundImage': 'url(' + item.picture + ')' }}>
                                            <div className="delete-cover">
                                                <i onClick={this.albumDel.bind(this, index)} className="iconfont icon-shanchuicon"></i>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            <div className="clickAddButton">
                                {
                                    drawImage.length < 9 && <div id="chooseDetailPic" className="chooseActivityPic"></div>
                                }
                            </div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">领取详情页文案</span>
                            <Input className="inputBlock" value={drawSlogan} onChange={this.inputItemChange.bind(this, 'drawSlogan')}></Input>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">领取详情页背景图</span>
                            <div id="chooseDrawImage" className="chooseActivityPic"></div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">红榜最大展位数</span>
                            <Input className="inputBlock" onPaste={(e) => e.preventDefault()} value={honourNum} onChange={this.inputItemChange.bind(this, 'honourNum')}></Input>
                            {hasClicked && errorArr.get('honourNum') && <span className="formItemError">请填写红榜最大展位数(限非负整数)</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">外部活动页</span>
                            <Radio.Group onChange={this.hasOutPageChange.bind(this)} value={hasOutPage}>
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </div>
                        {
                            hasOutPage == 1 &&
                            <div className="inputItem">
                                <span className="inputTitle">活动标题</span>
                                <Input className="inputBlock" value={outTitle} onChange={this.inputItemChange.bind(this, 'outTitle')}></Input>
                                {hasClicked && errorArr.get('outTitle') && <span className="formItemError">请填写活动标题</span>}
                            </div>
                        }
                        {
                            hasOutPage == 1 &&
                            <div className="inputItem">
                                <span className="inputTitle">活动头图</span>
                                <div id="chooseOutActivityHeadImage" className="chooseActivityPic"></div>
                                {hasClicked && errorArr.get('outHeadImage') && <span className="formItemError">请选择活动头图</span>}
                            </div>
                        }
                        {
                            hasOutPage == 1 &&
                            <div className="inputItem align-flex-start">
                                <span className="inputTitle">活动详情</span>
                                <div className="editorPane">
                                    {
                                        !getActivity && <UEditor id={'myeditor2'} ready={this.UEditorReadyOutContent.bind(this)} onChange={this.handleUEditorChange.bind(this, 'outContent')} />
                                    }
                                    {hasClicked && errorArr.get('outContent') && <span className="editorItemError">请填写活动详情</span>}
                                </div>
                            </div>
                        }
                        {
                            (activityType == 3 || activityType == 4) &&
                            <div className="inputItem">
                                <span className="inputTitle">链接卡标题</span>
                                <Input className="inputBlock" value={shareTitle} onChange={this.inputItemChange.bind(this, 'shareTitle')}></Input>
                                {hasClicked && errorArr.get('shareTitle') && <span className="formItemError">请填写链接卡标题</span>}
                            </div>
                        }
                        {
                            (activityType == 3 || activityType == 4) &&
                            <div className="inputItem">
                                <span className="inputTitle">祝福语</span>
                                <Input className="inputBlock" value={shareGreeting} onChange={this.inputItemChange.bind(this, 'shareGreeting')}></Input>
                                {hasClicked && errorArr.get('shareGreeting') && <span className="formItemError">请填写祝福语</span>}
                            </div>
                        }
                        {
                            (activityType == 3 || activityType == 4) &&
                            <div className="inputItem">
                                <span className="inputTitle">故事</span>
                                <Input className="inputBlock" value={shareStory} onChange={this.inputItemChange.bind(this, 'shareStory')}></Input>
                                {hasClicked && errorArr.get('shareStory') && <span className="formItemError">请填写故事</span>}
                            </div>
                        }
                        <div className="inputItem">
                            <span className="inputTitle">铛铛助手标题</span>
                            <Input className="inputBlock" value={linkTitle} onChange={this.inputItemChange.bind(this, 'linkTitle')}></Input>
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">铛铛助手摘要</span>
                            <Input className="inputBlock" value={linkDesc} onChange={this.inputItemChange.bind(this, 'linkDesc')}></Input>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">铛铛助手头图</span>
                            <div id="chooseLinkImage" className="chooseActivityPic">
                            </div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">弹出海报图</span>
                            <div id="chooseBounceImage" className="chooseActivityPic">

                            </div>
                        </div>
                        {
                            activityType == 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">加入使用铛铛助手标题</span>
                                <Input className="inputBlock" value={joinLinkTitle} onChange={this.inputItemChange.bind(this, 'joinLinkTitle')}></Input>
                            </div>
                        }
                        {
                            activityType == 2 && <div className="inputItem align-flex-start">
                                <span className="inputTitle">加入使用铛铛助手摘要</span>
                                <Input className="inputBlock" value={joinLinkDesc} onChange={this.inputItemChange.bind(this, 'joinLinkDesc')}></Input>
                            </div>
                        }
                        {
                            activityType == 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">加入使用铛铛助手头图</span>
                                <div id="chooseJoinLinkImage" className="chooseActivityPic">

                                </div>
                            </div>
                        }
                        {
                            activityType == 2 &&
                            <div className="inputItem">
                                <span className="inputTitle">5分钟前通知铛铛助手标题</span>
                                <Input className="inputBlock" value={pre5LinkTitle} onChange={this.inputItemChange.bind(this, 'pre5LinkTitle')}></Input>
                            </div>
                        }
                        {
                            activityType == 2 &&
                            <div className="inputItem align-flex-start">
                                <span className="inputTitle">5分钟前通知铛铛助手摘要</span>
                                <Input className="inputBlock" value={pre5LinkDesc} onChange={this.inputItemChange.bind(this, 'pre5LinkDesc')}></Input>
                            </div>
                        }
                        {
                            activityType == 2 && <div className="inputItem">
                                <span className="inputTitle">5分钟前通知铛铛助手头图</span>
                                <div id="choosePre5LinkImage" className="chooseActivityPic">

                                </div>
                            </div>
                        }
                        <Button onClick={this.saveActivity.bind(this)}>发布活动</Button>
                    </div>
                </ConfigProvider>
            </DocumentTitle>
        )
    }
}
export default PublishActivity;
